import React from 'react'
import Link from 'next/link'
import moment from 'moment'

const Footer = () => {
  return (
    <footer className='Footer'>
      <div className='Footer__main'>
        <div className='container'>
          <div className='Footer__top'>
            <div className='Footer__brand'>
              <img
                className='Footer__brand__logo'
                src='/images/logo-white.svg'
                alt='datawow'
              />
              <div className='Footer__brand__badges'>
                <img src='/images/iso-ism.svg' alt='ISO27001' loading='lazy' />
                <img src='/images/iso-pim.svg' alt='ISO27701' loading='lazy' />
              </div>
            </div>

            <div className='Footer__right-group'>
              <div className='Footer__address'>
                <h4 className='Footer__heading'>Address</h4>
                <p className='Footer__text'>
                  7 Summer Point Building, 2nd Floor, Soi
                  <br />
                  Sukhumvit 69, Phra Khanong Nuea,
                  <br />
                  Watthana, Bangkok 10110, Thailand.
                </p>
                <h4 className='Footer__heading Footer__heading--mt'>
                  Follow Us
                </h4>
                <div className='Footer__socials'>
                  <a
                    href='https://www.facebook.com/datawowai/'
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    aria-label='Facebook'
                  >
                    <img
                      src='/images/footer/facebook.svg'
                      alt='Facebook'
                      width='22'
                      height='22'
                    />
                  </a>
                  <a
                    href='https://www.linkedin.com/company/datawowio/'
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    aria-label='LinkedIn'
                  >
                    <img
                      src='/images/footer/linkedin.svg'
                      alt='LinkedIn'
                      width='22'
                      height='22'
                    />
                  </a>
                  <a
                    href='https://www.youtube.com/@datawow'
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    aria-label='YouTube'
                  >
                    <img
                      src='/images/footer/youtube.svg'
                      alt='YouTube'
                      width='22'
                      height='22'
                    />
                  </a>
                  <a
                    href='https://www.tiktok.com/@datawow'
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    aria-label='TikTok'
                  >
                    <img
                      src='/images/footer/tiktok.svg'
                      alt='TikTok'
                      width='22'
                      height='22'
                    />
                  </a>
                </div>
              </div>

              <div className='Footer__contact'>
                <h4 className='Footer__heading'>Contact US</h4>
                <div className='Footer__contact__item'>
                  <img
                    src='/images/footer/call.svg'
                    alt='Phone'
                    width='16'
                    height='16'
                  />
                  <a href='tel:020245560'>02-024-5560</a>
                </div>
                <div className='Footer__contact__item'>
                  <img
                    src='/images/footer/mail.svg'
                    alt='Email'
                    width='16'
                    height='16'
                  />
                  <a href='mailto:sales@datawow.io'>sales@datawow.io</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='Footer__bottom'>
        <div className='container'>
          <div className='Footer__bottom__left'>
            <Link href='/policy'>
              <a>Privacy Policy</a>
            </Link>
            <Link href='/security'>
              <a>Security</a>
            </Link>
          </div>
          <div className='Footer__bottom__right'>
            <p>
              &copy; {moment().year()} Data Wow Co., Ltd. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
